import {makeEl} from "../../common/Utils";
import DataStore from "../DataStore";
import {svgIcoChangePlus} from "../SvgCode";
import Layer from "../Layer";
import {IFamilySiteList} from "../../interface/IFooter";

export default  class FamilySite{
    private ds: DataStore;
    private btn!: HTMLButtonElement;
    private ul!: HTMLUListElement;

    constructor(_wrapper: HTMLElement) {
        this.ds = DataStore.instance;
        if(this.ds.config.familySiteList){
            this.templ(_wrapper, this.ds.config.familySiteList);
            this.addEvents();
        }
    }

    templ(_parent: HTMLElement, _familySiteInfo: Array<IFamilySiteList>){
        const tmpl = makeEl('div', _parent, {class: 'footer-change-wrap'});
        tmpl.classList.add('footer-family-sites');
        const innerTmpl = makeEl('div',tmpl, {class: 'footer-change-inner'} );
        this.btn = makeEl('button', innerTmpl, {class: 'btn-footer-change'});

        this.btn.innerHTML= `
            <span class="inner-txt">Family Site</span>
            ${svgIcoChangePlus}
        `;
        this.ul = makeEl('ul', tmpl, {class: 'footer-change-list', id: 'FooterFamilySiteChangeList'});
        _familySiteInfo.map(it => this.liTempl(this.ul, it));
    }

    liTempl(_parent: HTMLUListElement, _data: {siteName: string, siteLink: string}){
        const li = makeEl('li', _parent, {class: 'footer-change-item'});
        const aEl = makeEl('a', li, {class: 'change-item-link', href: _data.siteLink});
        makeEl('span', aEl, undefined, _data.siteName);
    }

    addEvents() {
        this.btn.addEventListener('click', e => {
            Layer.toggleLayer(this.ul.id);
            e.stopPropagation();
        });
    }
}